import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useTranslation } from 'react-i18next'
import FormTextField from './FormTextField'

const FormTimePicker = ({ formProps, inputConfig, itemProps }) => {
  const { t } = useTranslation()

  const { label, disabled } = itemProps || {}
  const { field: { ref, onChange, ...fieldProps } = {} } = formProps || {}

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        disabled={disabled}
        label={label}
        onChange={value => {
          onChange(value?.toDate())
        }}
        minTime={itemProps?.timeprops?.minTime}
        maxTime={itemProps?.timeprops?.maxTime}
        {...fieldProps}
        renderInput={params => {
          const { InputProps, inputProps, inputRef } = params
          return (
            <FormTextField
              InputProps={InputProps}
              inputRef={inputRef}
              inputProps={{
                ...inputProps,
                placeholder: t('format.date'),
              }}
              itemProps={itemProps}
              formProps={formProps}
              inputConfig={{ sx: { width: 160 }, ...inputConfig }}
            />
          )
        }}
      />
    </LocalizationProvider>
  )
}

export default FormTimePicker
